import qs from 'qs'
import { useHistory, useLocation } from 'react-router-dom'

import { R } from 'core/helpers'

type options = {
  enableBoolean?: boolean
  enableNumber?: boolean
  enabledNullOrUndefined?: boolean
}

const useQueryString = <T>(defaultValues: T, options: options = {}) => {
  const history = useHistory()

  const location = useLocation()

  const query = (
    location.search
      ? qs.parse(location.search, {
          ignoreQueryPrefix: true,
          decoder: (value: any) => {
            const { enableBoolean, enableNumber, enabledNullOrUndefined } =
              options ?? {}

            if (enableNumber && /^(\d+|\d*\.\d+)$/.test(value))
              return Number.parseFloat(value)

            const keywords = {
              ...(enableBoolean ? { true: true, false: false } : {}),
              ...(enabledNullOrUndefined
                ? { null: null, undefined: undefined }
                : {}),
            }

            if (value in keywords) {
              return keywords[value]
            }

            return decodeURIComponent(value)
          },
        })
      : {}
  ) as {
    [P in keyof T]?: Exclude<T[P], null> | undefined
  }

  return [
    R.merge(defaultValues, query),
    (values: { [P in keyof T]?: T[P] | null } | null) =>
      history.push(
        values === null
          ? location.pathname
          : qs.stringify(R.merge(query, values), {
              addQueryPrefix: true,
              skipNulls: true,
            }),
      ),
  ] as const
}

export default useQueryString
